export const SezzlePay = ({ finalPrice, productDetails }: { finalPrice: number; productDetails: any }) => {
  return (
    <div className='mt-2.5 lg_mt-5 '>
      <span className='font-roboto-regular text-sm font-normal leading-none lg_text-lg'>
        Or 4 interest-free payments of{' '}
        <span className=''>${((finalPrice || productDetails.price.value) / 4).toFixed(2)}</span> with
      </span>
      <img
        src={'/Sezzle_Logo_FullColor.svg'}
        alt='Sezzle logo'
        title='Pay in 4 interest-free payments with Sezzle'
        className='ml-[5px] inline w-[72px] -translate-y-0.5 lg_w-20'
      />
    </div>
  );
};
